exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".app-modal-header{text-align:left}.app-modal-footer{text-align:right}", "", {"version":3,"sources":["/opt/snt/front-end-turnos/src/app/turnos/shared/modal/modal-cancelar-turno/modal-cancelar-turno.component.scss"],"names":[],"mappings":"AAAA,kBACC,eAAgB,CAChB,kBAEA,gBAAiB,CACjB","file":"modal-cancelar-turno.component.scss","sourcesContent":[".app-modal-header {\r\n\ttext-align: left;\r\n}\r\n.app-modal-footer {\r\n\ttext-align: right;\r\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/snt/front-end-turnos/src/app/turnos/shared/modal/modal-cancelar-turno/modal-cancelar-turno.component.scss
// module id = ICXv
// module chunks = 2